import React, { ReactElement } from 'react';
import { ConfirmModal } from 'slovlex-idsk-react-components';
import { Button } from 'idsk-react-components';
import { useClient } from '../../../../../../context/ClientStatusContext';
import { useSuccessMessageContext } from '../../../../../../context/SuccessMessageContext';
import LegislativnyMaterialItem from '../../../../../../model/pracovnyKrok/LegislativnyMaterialItem';
import { restartProcessInstance } from '../../../../../../client/legislativnyMaterial/restartProcessInstanceClient';

interface Props {
  confirmActionQuestion?: string;
  description?: string;
  reloadDetail?: () => void;
  legMaterial: LegislativnyMaterialItem;
  setIsDropdownOpened: (isDropdownOpened: boolean) => void;
}

const ModalRestartProcessInstance = ({
  confirmActionQuestion,
  description,
  reloadDetail,
  legMaterial,
  setIsDropdownOpened,
}: Props): ReactElement => {
  const {
    displaySuccess,
  } = useSuccessMessageContext();

  const {
    wrapClient: restartProcessInstanceClient,
  } = useClient(restartProcessInstance);

  const handleRestartProcessInstance = async (): Promise<void> => {
    await restartProcessInstanceClient(legMaterial?.uuid);

    if (reloadDetail !== undefined) {
      reloadDetail();
    }

    displaySuccess('Proces bol úspešne spustený. Prosím, skontrolujte metadáta materiálu, správne priradenie '
      + 'aktuálneho predkladateľa a aktuálnej zodpovednej inštitúcie. V prípade potreby vykonajte '
      + 'zmeny a následne funkcionalitou "Zmena štádia materiálu" uveďte proces do korektného stavu.');
  };

  return (
    <ConfirmModal
      question={confirmActionQuestion}
      description={description}
      cancelButtonText="Nie"
      confirmButton={
        (
          <Button
            buttonStyle="action"
            size="large"
          >
            Áno
          </Button>
        )
      }
      openButton={(
        <Button
          className="admin-funkcionalita__button"
          key="ozivenie-ukonceneho-procesu"
          buttonStyle="link"
          size="small"
          onClick={() => {
            setIsDropdownOpened(false);
          }}
        >
          Oživenie ukončeného procesu
        </Button>
      )}
      doAfterConfirm={handleRestartProcessInstance}
    />
  );
};

export default ModalRestartProcessInstance;
